var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(" "+_vm._s(_vm.translationKeywords['page-not-found'] || 'The website is under construction'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }